import { Address } from '../../sharedComponents/common.types';

import { ApiAddress, ApiOptionalAddress } from '../types/address.types';

export const mapToAddress = (apiAddress: ApiAddress): Address => {
    return {
        name: `${apiAddress.name}${
            apiAddress.additional_name_information != null ? ' ' + apiAddress.additional_name_information : ''
        }`,
        street: `${apiAddress.street}${
            apiAddress.additional_street_information != null ? ' ' + apiAddress.additional_street_information : ''
        }`,
        postalCode: apiAddress.postal_code,
        city: apiAddress.city,
        countryCode: apiAddress.country_code,
    };
};

export const mapToPartialAddress = (apiAddress: ApiOptionalAddress): Partial<Address> | undefined => {
    const { additional_name_information, additional_street_information, ...rest } = apiAddress;
    const addressIsEmpty = Object.values(rest).every((value) => value === undefined);
    return addressIsEmpty
        ? undefined
        : {
              name:
                  apiAddress.name &&
                  `${apiAddress.name}${
                      additional_name_information !== undefined ? ' ' + additional_name_information : ''
                  }`,
              street:
                  apiAddress.street &&
                  `${apiAddress.street}${
                      additional_street_information !== undefined ? ' ' + additional_street_information : ''
                  }`,
              postalCode: apiAddress.postal_code,
              city: apiAddress.city,
              countryCode: apiAddress.country_code,
          };
};
